import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_CRUD} from './_Action'
import {_PAGINATE} from './paginateAction'
import { ProductCriteria } from 'src/type/criteria/productCriteria'

export const PRODUCTS = 'products'
const _PRODUCTS_PAGINATE = _PAGINATE(PRODUCTS)

export const fetchProducts = (criteria?: ProductCriteria) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [_PRODUCTS_PAGINATE.REQUEST, _PRODUCTS_PAGINATE.SUCCESS, _PRODUCTS_PAGINATE.FAILURE],
      route: route.products.search(enterpriseId, criteria)
    }
  })
}

export const fetchMoreProducts = (c: ProductCriteria) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [_PRODUCTS_PAGINATE.FETCH_MORE_REQUEST, _PRODUCTS_PAGINATE.FETCH_MORE_SUCCESS, _PRODUCTS_PAGINATE.FETCH_MORE_FAILURE],
        route: route.products.search(enterpriseId, c)
      }
    })
}

export const PRODUCTS_CHANGE = 'productsChange'
const _PRODUCTS_PAGINATE_CHANGE = _PAGINATE(PRODUCTS_CHANGE)
export const PRODUCTS_PLACEMENT = 'productsPlacement'
const _PRODUCTS_PAGINATE_PLACEMENT = _PAGINATE(PRODUCTS_PLACEMENT)
export const PRODUCTS_DETTE = 'productsDette'
const _PRODUCTS_PAGINATE_DETTE = _PAGINATE(PRODUCTS_DETTE)

export const fetchProductsChange = (criteria?: ProductCriteria) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [_PRODUCTS_PAGINATE_CHANGE.REQUEST, _PRODUCTS_PAGINATE_CHANGE.SUCCESS, _PRODUCTS_PAGINATE_CHANGE.FAILURE],
      route: route.products.search(enterpriseId, criteria)
    }
  })
}

export const fetchProductsPlacement = (criteria?: ProductCriteria) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [_PRODUCTS_PAGINATE_PLACEMENT.REQUEST, _PRODUCTS_PAGINATE_PLACEMENT.SUCCESS, _PRODUCTS_PAGINATE_PLACEMENT.FAILURE],
      route: route.products.search(enterpriseId, criteria)
    }
  })
}

export const fetchProductsDette = (criteria?: ProductCriteria) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [_PRODUCTS_PAGINATE_DETTE.REQUEST, _PRODUCTS_PAGINATE_DETTE.SUCCESS, _PRODUCTS_PAGINATE_DETTE.FAILURE],
      route: route.products.search(enterpriseId, criteria)
    }
  })
}

export const PRODUCT = 'product'
const _PRODUCT_CRUD = _CRUD(PRODUCT)

export const getProduct = (id: string) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [_PRODUCT_CRUD.GET.REQUEST, _PRODUCT_CRUD.GET.SUCCESS, _PRODUCT_CRUD.GET.FAILURE],
        route: route.products.get(enterpriseId, id)
      }
    })
}

export const getProductByType = (type: string) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
    return dispatch({
      [_CALL_API]: {
        types: [_PRODUCT_CRUD.GET.REQUEST, _PRODUCT_CRUD.GET.SUCCESS, _PRODUCT_CRUD.GET.FAILURE],
        route: route.products.getByType(enterpriseId, type)
      }
    })
}


// WEBPACK FOOTER //
// ./src/core/redux/action/productsAction.ts